const DefaultIcon = ({ color = '#314158', width = '16px', height = '16px' }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.6673 13.332V2.66536C10.6673 2.31174 10.5268 1.9726 10.2768 1.72256C10.0267 1.47251 9.68761 1.33203 9.33398 1.33203H6.66732C6.3137 1.33203 5.97456 1.47251 5.72451 1.72256C5.47446 1.9726 5.33398 2.31174 5.33398 2.66536V13.332"
				stroke={color}
				strokeWidth="1.33333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.334 4H2.66732C1.93094 4 1.33398 4.59695 1.33398 5.33333V12C1.33398 12.7364 1.93094 13.3333 2.66732 13.3333H13.334C14.0704 13.3333 14.6673 12.7364 14.6673 12V5.33333C14.6673 4.59695 14.0704 4 13.334 4Z"
				stroke={color}
				strokeWidth="1.33333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default DefaultIcon;

